import React from 'react';

interface TableProps {
  valuePerShare: number;
  actualTitan: number;
  minTitan: number;
  finalTitan: number;
  actualPioneer: number;
  minPioneer: number;
  finalPioneer: number;
  titanPrice: number;
  pioneerPrice: number;
}

export const RewardAnalysisTable: React.FC<TableProps> = ({
  valuePerShare, actualTitan, minTitan, finalTitan,
  actualPioneer, minPioneer, finalPioneer, titanPrice, pioneerPrice
}) => {
  const formatCurrency = (val: number) => 
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(val);

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h4 className="text-lg font-bold text-gray-800 mb-4 border-b pb-2">Phân Tích Thưởng Gói Đầu Tư</h4>
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-50 text-gray-600 text-sm uppercase tracking-wider">
              <th className="p-3 border-b border-gray-200 font-semibold rounded-tl-lg">Loại Gói</th>
              <th className="p-3 border-b border-gray-200 font-semibold text-right">Phân bổ thực tế</th>
              <th className="p-3 border-b border-gray-200 font-semibold text-right">Bảo chứng (3%)</th>
              <th className="p-3 border-b border-gray-200 font-semibold text-right bg-blue-50 text-blue-900 rounded-tr-lg">Thưởng Thực Nhận</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {/* Titan Row */}
            <tr className="hover:bg-gray-50 border-b border-gray-100">
              <td className="p-4">
                <div className="font-bold text-gray-800">Gói Titan</div>
                <div className="text-xs text-gray-500 mt-1">Công thức: MAX( Giá trị 1 phần × 6 ; 3% × Giá trị gói )</div>
              </td>
              <td className={`p-4 text-right ${actualTitan > minTitan ? 'text-green-600 font-bold' : 'text-gray-700'}`}>
                <div>{formatCurrency(actualTitan)}</div>
                <div className="text-xs text-gray-400">{formatCurrency(valuePerShare)} × 6</div>
              </td>
              <td className={`p-4 text-right ${minTitan >= actualTitan ? 'text-green-600 font-bold' : 'text-gray-700'}`}>
                <div>{formatCurrency(minTitan)}</div>
                <div className="text-xs text-gray-400">3% × {formatCurrency(titanPrice)}</div>
              </td>
              <td className="p-4 text-right bg-blue-50/50 font-bold text-blue-900 text-lg">{formatCurrency(finalTitan)}</td>
            </tr>
            {/* Pioneer Row */}
            <tr className="hover:bg-gray-50">
              <td className="p-4">
                <div className="font-bold text-gray-800">Gói Pioneer</div>
                <div className="text-xs text-gray-500 mt-1">Công thức: MAX( Giá trị 1 phần ; 3% × Giá trị gói )</div>
              </td>
              <td className={`p-4 text-right ${actualPioneer > minPioneer ? 'text-green-600 font-bold' : 'text-gray-700'}`}>
                <div>{formatCurrency(actualPioneer)}</div>
                <div className="text-xs text-gray-400">{formatCurrency(valuePerShare)} × 1</div>
              </td>
              <td className={`p-4 text-right ${minPioneer >= actualPioneer ? 'text-green-600 font-bold' : 'text-gray-700'}`}>
                <div>{formatCurrency(minPioneer)}</div>
                <div className="text-xs text-gray-400">3% × {formatCurrency(pioneerPrice)}</div>
              </td>
              <td className="p-4 text-right bg-blue-50/50 font-bold text-blue-900 text-lg">{formatCurrency(finalPioneer)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg flex items-start">
        <i className="fas fa-info-circle text-yellow-500 mt-0.5 mr-2"></i>
        <p className="text-sm text-yellow-800">
          <strong>Lưu ý về chính sách:</strong> Hệ thống tự động so sánh thu nhập từ việc chia sẻ quỹ chung và mức bảo chứng 3% giá trị gói. Nhà đầu tư sẽ luôn nhận được mức <strong>cao hơn (hàm MAX)</strong>.
        </p>
      </div>
    </div>
  );
};